import { enumSchema, objectSchema } from "vue-utils"
import { extend, GenericEntity, Id, Nullable } from "./GenericEntity"
import { SystemRole } from "./SystemRole"

export interface User extends GenericEntity {
	guid: string
	firstName: string
	lastName: string
	emailAddress: string
	role: SystemRole
	loginEnabled: boolean
	companyId: Nullable<Id>
}

export const User = objectSchema<User>({
	...extend(GenericEntity),
	guid: String,
	firstName: String,
	lastName: String,
	emailAddress: String,
	role: enumSchema(SystemRole),
	loginEnabled: Boolean,
	companyId: Nullable(Id),
})
